module.exports = __webpack_public_path__ + "img/dummyprod4@1x.7a549e1d.png";